import * as React from "react";
import { useFetchEventJourney } from "../networks";

const useHideStatisticAndHallOfFame = (city = "", dataHof = {}) => {
  const { data: dataRaw } = useFetchEventJourney();

  const dataPastEvent = dataRaw?.data?.data?.events ?? [];

  const isHideStatisticOrHOF = React.useMemo(() => {
    console.log({
      dataPastEvent,
      dataHof,
      waaaaaaa: dataPastEvent?.find(
        (data) => String(data?.city).toLowerCase() === city
      ),
    });
    if (!!dataPastEvent) {
      return !!dataPastEvent?.find(
        (data) => String(data?.city).toLowerCase() === city
      );
    }

    return true;
  }, [dataPastEvent]);

  return {
    isHideStatisticOrHOF:
      isHideStatisticOrHOF && Object.keys(dataHof)?.length <= 0,
  };
};

export default useHideStatisticAndHallOfFame;
